// export const BASE_URL = "http://127.0.0.1:8000";
// export const BASE_URL = "http://35.206.194.203:5040";
// export const BASE_URL = "https://api.chatbot-world.com:6010";  //prod 2
export const BASE_URL = "https://api.quantumaisystems.com:6040";  //prod 1


export const HITL_BASE_URL = "https://api.chatbot-world.com:6030";
// export const BASE_URL = "http://35.206.194.203:5010";
// export const BASE_URL = "https://3f5e1ad9d5eb.ngrok-free.app";

// export const BASE_URL = "https://api.educareit.com:6025";

// export const BASE_URL = "https://ucdp.bigdatamatica.com:6025";  // fast api
// export const BASE_URL = "https://api.chatbot-world.com:6012";  // flask api
// export const BASE_URL = "https://api.chatbot-world.com:6020";  // Docker api

// export const COMMAND_BASE_URL = "http://35.206.245.118:8000";  // command center api


